import { create } from "zustand";
import { axiosInstance } from "../lib/axios";
import toast from "react-hot-toast";

interface AttendanceState {
  clockedIn: boolean;
  loading: boolean;

  checkStatus: () => Promise<void>;
  timeIn: () => Promise<void>;
  timeOut: () => Promise<void>;
}

export const useAttendanceStore = create<AttendanceState>((set, get) => ({
  clockedIn: false,
  loading: false,

  checkStatus: async () => {
    try {
      const res = await axiosInstance.get("/attendance/status");
      set({ clockedIn: res.data.clockedIn });
    } catch (err) {
      console.error("Status Error", err);
    }
  },

  timeIn: async () => {
    set({ loading: true });
    try {
      await axiosInstance.post("/attendance/clock-in");
      set({ clockedIn: true });
      toast.success("Clocked In");
    } catch {
      toast.error("Failed to clock in");
    } finally {
      set({ loading: false });
    }
  },

  timeOut: async () => {
    set({ loading: true });
    try {
      await axiosInstance.post("/attendance/clock-out");
      set({ clockedIn: false });
      toast.success("Clocked Out");
    } catch {
      toast.error("Failed to clock out");
    } finally {
      set({ loading: false });
    }
  },
}));
